import Cookies from 'universal-cookie';
import { getHostname } from './get-hostname';
import { getDomain } from './get-domain';
import { getRegion } from './get-region';
import { getDatePlusYear } from './date-time-helpers';

export const setUserRegionCookie = (host: string | null) => {
  const cookies = new Cookies();
  const userRegionCookie = '_userRegion';
  const currentCookieValue = cookies.get(userRegionCookie);
  const hostname = getHostname(host || '');
  const domain = getDomain(hostname);
  const normalizedDomain = domain.endsWith('/') ? domain.slice(0, -1) : domain;
  const region = getRegion(hostname, normalizedDomain);

  if (!currentCookieValue || currentCookieValue !== region) {
    cookies.set(userRegionCookie, region, {
      path: '/',
      expires: getDatePlusYear(),
      domain: `.${normalizedDomain}`,
    });
  }
};
